import { useSafeNavigation } from './useSafeNavigation';
import { useXmlDataStore } from './useXmlDataStore';

export const useClaimsUploadProcessController = () => {
  const { xmlDataModel } = useXmlDataStore();
  const { safeNavigate } = useSafeNavigation();

  if (xmlDataModel.isEmpty) {
    safeNavigate('/upload', { replace: true });
  }

  const updateProcess = () => {
    if (xmlDataModel.isEmpty) {
      safeNavigate('/upload', { replace: true });
      return;
    }

    if (xmlDataModel.batchId) {
      safeNavigate(`/upload/batch/${xmlDataModel.batchId}/billing`);
      return;
    }

    safeNavigate('/upload/claims/create-batch');
  };

  return {
    updateProcess,
  };
};
